import { NativeSelect } from "@mui/material";
import { FormizoSchema } from "Components/LabIZO/Formizo";
import { ConditionOperator, CustomFilterValueProps, FieldType, Filterable, TablizoSchema } from "Components/LabIZO/Tablizo";
import _ from "lodash";
import { Accessor } from "static";

const Table: TablizoSchema[] = [
  {
    label: "FAQ ID",
    name: "FAQ_id",
    filterable: true,
  },
  {
    label: "Language",
    name: "language",
    filterable: true,
  },
  {
    label: "Count(User Input)",
    name: "count_userInput.length",
    valueGetter: (row, field, addOns) => {
      let count_userInput = Accessor.Get(row, "count_userInput.length");
      return count_userInput !== undefined ? count_userInput : "";
    },
  },
  {
    label: "Count(Image URL)",
    name: "count_imageURL.length",
    valueGetter: (row, field, addOns) => {
      let count_userInput = Accessor.Get(row, "count_imageURL.length");
      return count_userInput !== undefined ? count_userInput : "";
    },
  },
  {
    label: "Count(Total)",
    name: "total.length",
    valueGetter: (row, field, addOns) => {
      let total = Accessor.Get(row, "total.length");
      return total !== undefined ? total : "";
    },
  },
];

const Info: FormizoSchema[] = [
  {
    label: "ID",
    name: "_id",
    validate: ["required"],
    format: "text",
    readOnly: true,
  },
  {
    label: "SessionID",
    name: "sessionID",
    format: "text",
    readOnly: true,
  },
  {
    label: "Datetime",
    name: "recTime",
    format: "text",
    readOnly: true,
  },
  {
    label: "Grade",
    name: "grade",
    format: "text",
    readOnly: true,
  },
  {
    label: "Reason",
    name: "reason",
    format: "text",
    readOnly: true,
  },
  {
    label: "Irrelevant",
    name: "irrelevant",
    format: "text",
    readOnly: true,
  },
  {
    label: "Incomplete",
    name: "incomplete",
    format: "text",
    readOnly: true,
  },
  {
    label: "Other Answer",
    name: "otherAnswer",
    format: "text",
    readOnly: true,
  },
  {
    label: "Selection",
    name: "selection",
    format: "text",
    readOnly: true,
  },
];

const Filterables: Filterable[] = [
  {
    field: "language",
    label: "Language",
    type: FieldType.text,
  },
  {
    field: "FAQ_id",
    label: "FAQ ID",
    type: FieldType.text,
  },
];

const Export = [
  {
    label: "FAQ ID",
    name: "FAQ_id",
  },
  {
    label: "Language",
    name: "language",
  },
  {
    label: "Count(User Input)",
    name: "count_userInput.length",
  },
  {
    label: "Count(Image URL)",
    name: "count_imageURL.length",
  },
  {
    label: "Count(Total)",
    name: "total.length",
  },
];

const AdvFilter: any = [];

const schema: any = {
  Table,
  Info,
  Export,
  AdvFilter,
  Filterables,
};

export default schema;
